/** Meta pixel "pixel martial arts de" 1457228929623029 (stockdigital.com, connected to the stockdigital 3 ad account).
 *  NEVER the English Martial pixel. PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID = '1457228929623029';
